import React from "react";
import { ShellHeader } from "@/components/shell/ShellContext";

/** The page's header lives in the top bar: title and count, an optional view switch, and the main actions */
export function PageHeader({ title, summary, switcher, actions }: { title: string; summary?: React.ReactNode; switcher?: React.ReactNode; actions?: React.ReactNode }) {
  return <ShellHeader title={title} count={summary} switcher={switcher} actions={actions} />;
}

/** Segmented control for switching how a list is shown (Board / Table) */
export function ViewSwitch<T extends string>({ value, options, onChange, label }: { value: T; options: { key: T; label: string }[]; onChange: (k: T) => void; label: string }) {
  return (
    <div role="group" aria-label={label} className="ml-2 hidden rounded-md bg-muted p-0.5 sm:flex">
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          aria-pressed={o.key === value}
          onClick={() => onChange(o.key)}
          className={`h-6 rounded-[5px] px-2.5 text-xs transition-colors ${o.key === value ? "bg-card font-semibold text-foreground shadow-xs" : "text-muted-foreground hover:text-foreground"}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
